import { render, staticRenderFns } from "./BaseSection.vue?vue&type=template&id=cabdd74a"
import script from "./BaseSection.vue?vue&type=script&lang=js"
export * from "./BaseSection.vue?vue&type=script&lang=js"
import style0 from "./BaseSection.vue?vue&type=style&index=0&id=cabdd74a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports